/**
 * Category rail - fill in the Style rows Shopify leaves out.
 *
 * On a big collection (All Brands, Shop by Category) Shopify does not send
 * every product type in the Style filter. It keeps the most common ones and
 * drops the smallest, so a style with only one or two products (Holiday,
 * Display, Berwick Bag, Detox...) never reaches the rail there - even though
 * filtering by it still works if the parameter is in the URL.
 *
 * The category's own collection (Toys, Bags & Accessories...) is much smaller
 * and does get the full list. So when exactly one subcategory is selected,
 * this fetches that category page, reads its Style rows, and adds any the
 * current rail is missing.
 *
 * Only when the current page holds every product the category page holds for
 * that subcategory - checked by comparing the subcategory counts. That keeps
 * it from doing anything on a brand page (fewer products, so it would offer
 * other brands' styles) or when a colour, availability or brand filter has
 * narrowed the page (the added counts would be wrong). In those cases Shopify's
 * own list is left exactly as it is.
 *
 * Added rows filter through the theme's own updateFiltersByURL, the same path
 * the filter chips and the stale-subcategory rows use, because there is no
 * checkbox in the facet form for a value Shopify did not send.
 */
(function () {
  if (window.__categoryRailFillBound) return;
  window.__categoryRailFillBound = true;

  var SUB_PARAM = 'filter.p.t.category';
  var CATEGORY_PARAM = 'filter.p.m.custom.hecho_category';
  var STYLE_PARAM = 'filter.p.product_type';
  var CAP = 6;
  var FILL_ATTR = 'data-category-rail-style-fill';

  /* Same groups, keywords and precedence as snippets/category-rail-styles.liquid.
     Keep the two in step. */
  var GROUP_DEFS = [
    ['Handbags', ['bag', 'tote']],
    ['Wallets', ['wallet', 'purse', 'card holder', 'coin pouch']],
    ['Cases', ['case']],
    ['Accessories', ['strap', 'tassel', 'passport holder', 'luggage tag', 'hat clip']]
  ];

  var cache = {};

  function params() {
    return new URLSearchParams(window.location.search);
  }

  function onCollection() {
    return /\/collections\/[^/]+/.test(window.location.pathname);
  }

  function collectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* Any filter other than category / subcategory / style narrows the page, and
     then the fetched counts no longer describe it. */
  function hasOtherFilters(p) {
    var other = false;
    p.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && key !== SUB_PARAM && key !== CATEGORY_PARAM && key !== STYLE_PARAM) {
        other = true;
      }
    });
    return other;
  }

  function railMap(root) {
    var el = root.querySelector('[data-category-rail-map]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function countOf(row) {
    var n = parseInt(text(row && row.querySelector('.category-rail__count')), 10);
    return isNaN(n) ? 0 : n;
  }

  function subCountIn(doc, subId) {
    var rows = doc.querySelectorAll('[data-category-rail] [data-filter-name="' + SUB_PARAM + '"]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-filter-value') === subId) return countOf(rows[i]);
    }
    return -1;
  }

  function fetchDoc(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          return html ? new DOMParser().parseFromString(html, 'text/html') : null;
        })
        .catch(function () {
          return null;
        });
    }
    return cache[url];
  }

  function withPreview(url) {
    var p = params();
    var preview = p.get('preview_theme_id');
    if (preview) url += (url.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + encodeURIComponent(preview);
    return url;
  }

  /* The category page's full Style list for one subcategory, plus its count. */
  function categoryStyles(handle, subId) {
    var url = withPreview('/collections/' + handle + '?' + SUB_PARAM + '=' + encodeURIComponent(subId));
    return fetchDoc(url).then(function (doc) {
      if (!doc) return null;
      var seen = {};
      var styles = [];
      var rows = doc.querySelectorAll('[data-category-rail] .category-rail__row--style[data-filter-value]');
      for (var i = 0; i < rows.length; i++) {
        var value = rows[i].getAttribute('data-filter-value');
        if (seen[value]) continue;
        seen[value] = true;
        styles.push({ value: value, label: text(rows[i].querySelector('.category-rail__label')) || value, count: countOf(rows[i]) });
      }
      return { subCount: subCountIn(doc, subId), styles: styles };
    });
  }

  /* This page's subcategory count before any style is applied. */
  function currentSubCount(root, subId) {
    var p = params();
    if (!p.getAll(STYLE_PARAM).length) return Promise.resolve(subCountIn(document, subId));
    var url = new URL(window.location.href);
    url.searchParams.delete(STYLE_PARAM);
    url.searchParams.delete('page');
    return fetchDoc(url.pathname + url.search).then(function (doc) {
      return doc ? subCountIn(doc, subId) : -1;
    });
  }

  function groupFor(label) {
    var hay = label.toLowerCase();
    for (var i = 0; i < GROUP_DEFS.length; i++) {
      var kws = GROUP_DEFS[i][1];
      for (var j = 0; j < kws.length; j++) {
        if (hay.indexOf(kws[j]) !== -1) return GROUP_DEFS[i][0];
      }
    }
    return null;
  }

  function styleUrl(value, add) {
    var url = new URL(window.location.href);
    var kept = url.searchParams.getAll(STYLE_PARAM).filter(function (v) {
      return v !== value;
    });
    url.searchParams.delete(STYLE_PARAM);
    kept.forEach(function (v) {
      url.searchParams.append(STYLE_PARAM, v);
    });
    if (add) url.searchParams.append(STYLE_PARAM, value);
    url.searchParams.delete('page');
    return url.toString();
  }

  function buildRow(style, active) {
    var li = document.createElement('li');
    li.className = 'category-rail__child';

    var a = document.createElement('a');
    a.className = 'category-rail__row category-rail__row--style' + (active ? ' is-active' : '');
    a.href = styleUrl(style.value, !active);
    a.setAttribute(FILL_ATTR, style.value);
    if (active) a.setAttribute('aria-current', 'true');

    var label = document.createElement('span');
    label.className = 'category-rail__label';
    label.textContent = style.label;
    a.appendChild(label);

    if (style.count > 0) {
      var count = document.createElement('span');
      count.className = 'category-rail__count';
      count.setAttribute('aria-hidden', 'true');
      count.textContent = style.count;
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = ', ' + style.count + ' products';
      a.appendChild(count);
      a.appendChild(sr);
    }

    li.appendChild(a);
    return li;
  }

  function rowsOf(list) {
    var out = [];
    var kids = list.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList.contains('category-rail__child') && !kids[i].classList.contains('category-rail__child--show-all')) {
        out.push(kids[i]);
      }
    }
    return out;
  }

  /* Alphabetical, among the plain style rows of this list. */
  function insertSorted(list, li, label) {
    var rows = rowsOf(list);
    var key = label.toLowerCase();
    for (var i = 0; i < rows.length; i++) {
      var other = text(rows[i].querySelector('.category-rail__label')).toLowerCase();
      if (other.localeCompare(key) > 0) {
        list.insertBefore(li, rows[i]);
        return;
      }
    }
    /* Last alphabetically: before "Show all" if there is one, else at the end
       (in a grouped list that is after the groups, where ungrouped rows live). */
    var showAll = list.querySelector(':scope > .category-rail__child--show-all');
    if (showAll) list.insertBefore(li, showAll);
    else list.appendChild(li);
  }

  /* Re-apply the six-row cap after rows were added, keeping "Show all" honest. */
  function recap(list) {
    var rows = rowsOf(list);
    var showAll = list.querySelector(':scope > .category-rail__child--show-all');
    var expanded = showAll ? showAll.hidden : false;

    if (rows.length <= CAP) return;

    if (!showAll) {
      showAll = document.createElement('li');
      showAll.className = 'category-rail__child category-rail__child--show-all';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'category-rail__show-all';
      button.setAttribute('data-category-rail-show-all', '');
      showAll.appendChild(button);
      list.appendChild(showAll);
    }
    var btn = showAll.querySelector('button');
    if (btn) {
      btn.textContent = 'Show all ' + rows.length;
      btn.hidden = false;
    }
    if (expanded) return;

    for (var i = 0; i < rows.length; i++) {
      var active = rows[i].querySelector('.is-active');
      if (i >= CAP && !active) {
        rows[i].classList.add('category-rail__child--overflow');
        rows[i].hidden = true;
      }
    }
  }

  function findGroupList(stylesRoot, name) {
    var groups = stylesRoot.querySelectorAll(':scope > .category-rail__style-group');
    for (var i = 0; i < groups.length; i++) {
      var label = text(groups[i].querySelector(':scope > .category-rail__row--style-group .category-rail__label'));
      if (label === 'All ' + name) return groups[i];
    }
    return null;
  }

  function existingValues(scope) {
    var have = {};
    var rows = scope.querySelectorAll('.category-rail__row--style');
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i].getAttribute('data-filter-value') || rows[i].getAttribute(FILL_ATTR);
      if (v !== null) have[v] = true;
    }
    return have;
  }

  function fillInto(subLi, styles) {
    var stylesRoot = subLi.querySelector(':scope > .category-rail__styles');
    var created = false;
    if (!stylesRoot) {
      /* Shopify sent one style or none, so the server drew no list at all. */
      stylesRoot = document.createElement('ul');
      stylesRoot.className = 'category-rail__styles';
      created = true;
    }

    var have = existingValues(stylesRoot);
    var active = params().getAll(STYLE_PARAM);
    var grouped = !!stylesRoot.querySelector(':scope > .category-rail__style-group');
    var touched = [];

    for (var i = 0; i < styles.length; i++) {
      var s = styles[i];
      if (have[s.value]) continue;
      var li = buildRow(s, active.indexOf(s.value) !== -1);
      var target = stylesRoot;

      if (grouped) {
        var name = groupFor(s.label);
        var group = name ? findGroupList(stylesRoot, name) : null;
        if (group) {
          target = group.querySelector(':scope > .category-rail__styles') || stylesRoot;
          if (target !== stylesRoot && rowsOf(target).length >= 1) target.hidden = false;
          var gCount = group.querySelector(':scope > .category-rail__row--style-group .category-rail__count');
          if (gCount && s.count) gCount.textContent = (parseInt(gCount.textContent, 10) || 0) + s.count;
        }
      }

      insertSorted(target, li, s.label);
      if (touched.indexOf(target) === -1) touched.push(target);
    }

    if (created) {
      /* A single style is redundant with the subcategory itself - the same rule
         the server render follows. */
      if (rowsOf(stylesRoot).length < 2) return;
      subLi.appendChild(stylesRoot);
    }
    for (var t = 0; t < touched.length; t++) recap(touched[t]);
  }

  function fill(root) {
    if (!onCollection()) return;
    var p = params();
    var subs = p.getAll(SUB_PARAM);
    if (subs.length !== 1 || hasOtherFilters(p)) return;
    var subId = subs[0];

    var entry = null;
    var map = railMap(root);
    for (var i = 0; i < map.length; i++) {
      if (map[i].id === subId) {
        entry = map[i];
        break;
      }
    }
    if (!entry) return;

    var handle = entry.group;
    if (!handle || handle === collectionHandle()) return;

    var subRow = null;
    var rows = root.querySelectorAll('[data-filter-name="' + SUB_PARAM + '"]');
    for (var j = 0; j < rows.length; j++) {
      if (rows[j].getAttribute('data-filter-value') === subId) {
        subRow = rows[j];
        break;
      }
    }
    var subLi = subRow ? subRow.closest('.category-rail__child') : null;
    if (!subLi) return;

    Promise.all([categoryStyles(handle, subId), currentSubCount(root, subId)]).then(function (res) {
      var cat = res[0];
      var here = res[1];
      if (!cat || !cat.styles.length || cat.subCount < 0 || here < cat.subCount) return;
      /* The rail may have been re-rendered while we waited. */
      if (!subLi.isConnected) return;
      fillInto(subLi, cat.styles);
    });
  }

  function fillAll() {
    var roots = document.querySelectorAll('[data-category-rail]');
    for (var i = 0; i < roots.length; i++) fill(roots[i]);
  }

  function host(node) {
    return node.closest('facets-form-component');
  }

  function go(node, url) {
    var h = host(node);
    if (h && typeof h.updateFiltersByURL === 'function') {
      h.updateFiltersByURL(url);
    } else {
      window.location.href = url;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

      var row = event.target.closest('[' + FILL_ATTR + ']');
      if (row) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var value = row.getAttribute(FILL_ATTR);
        var on = params().getAll(STYLE_PARAM).indexOf(value) !== -1;
        go(row, styleUrl(value, !on));
        schedule();
        return;
      }

      /* "All Handbags" ticks checkboxes, and an added row has none - so when a
         group holds added rows, the whole group is applied as one URL edit. */
      var groupBtn = event.target.closest('[data-category-rail-group-select]');
      if (groupBtn) {
        var group = groupBtn.closest('.category-rail__style-group');
        if (!group || !group.querySelector('[' + FILL_ATTR + ']')) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        var values = [];
        var styleRows = group.querySelectorAll('.category-rail__row--style');
        for (var i = 0; i < styleRows.length; i++) {
          var v = styleRows[i].getAttribute('data-filter-value') || styleRows[i].getAttribute(FILL_ATTR);
          if (v !== null) values.push(v);
        }
        var current = params().getAll(STYLE_PARAM);
        var allOn = values.every(function (v) {
          return current.indexOf(v) !== -1;
        });

        var url = new URL(window.location.href);
        var kept = current.filter(function (v) {
          return values.indexOf(v) === -1;
        });
        url.searchParams.delete(STYLE_PARAM);
        kept.forEach(function (v) {
          url.searchParams.append(STYLE_PARAM, v);
        });
        if (!allOn) {
          values.forEach(function (v) {
            url.searchParams.append(STYLE_PARAM, v);
          });
        }
        url.searchParams.delete('page');
        go(groupBtn, url.toString());
        schedule();
        return;
      }

      /* Any other rail row also changes the filters; refill once it re-renders. */
      if (event.target.closest('[data-category-rail]')) schedule();
    },
    true
  );

  /* Availability, Colour and the other facet checkboxes re-render the rail too. */
  document.addEventListener('change', schedule, true);
  window.addEventListener('popstate', schedule);

  /* The rail is swapped in again after every filter change, and the last pass
     can land well after a second, so refill on a ladder rather than once. Every
     step skips rows that are already there, so repeated runs are safe. */
  var LADDER = [150, 600, 1200, 2000, 3000];
  function schedule() {
    LADDER.forEach(function (delay) {
      setTimeout(fillAll, delay);
    });
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (
          (n.matches && n.matches('[data-category-rail]')) ||
          (n.querySelector && n.querySelector('[data-category-rail]')) ||
          (n.closest && n.closest('[data-category-rail]') && !n.closest('[' + FILL_ATTR + ']') && !(n.querySelector && n.querySelector('[' + FILL_ATTR + ']')) && !n.classList.contains('category-rail__child'))
        ) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', fillAll);
  fillAll();
})();
